<template>
  <div>
    <h2>Контакты</h2>

    <!-- buttons -->
    <b-row class="my-3">
      <b-col class="d-flex justify-content-between">
        <b-button
          v-b-modal.modal-1
          @click="onCreateButton"
          size="sm"
        >
          Добавить
        </b-button>
        <b-button
          variant="outline-primary"
          size="sm"
          style="border: none;"
          @click="isShowFilters = !isShowFilters"
        >
          <b-icon icon="filter" />
          Показать фильтр
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <!-- search form -->
        <search-form
          :error-result="errorResult"
          :message-result="messageResult"
          :search-query="searchQuery"
          :submit-search="submitSearch"
          name-label="Быстрый поиск"
          :reset-search="resetSearch"
          :is-show-filters="isShowFilters"
        />
      </b-col>
    </b-row>

    <!-- modal  -->
    <b-modal id="modal-1" size="lg" title="Новый контакт" hide-footer>
      <b-form @submit="createContact" size="sm">
        <b-form-group label="Фамилия:" label-cols-sm="4" label-cols-lg="4" aria-required="true">
          <b-form-input
              type="text"
              v-model="form.last_name"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Имя:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              type="text"
              v-model="form.first_name"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Отчество:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              type="text"
              v-model="form.middle_name"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Телефон:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              v-model="form.phone"
              type="text"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="E-mail:" label-cols-sm="4" label-cols-lg="4">
          <b-form-input
              v-model="form.email"
              type="email"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Дата рождения:" label-cols-sm="4" label-cols-lg="4">
          <date-picker
            v-model="form.birth_date"
            placeholder="Выберите дату"
            :lang="datepicker.lang"
            :format="datepicker.format"
            :value-type="datepicker.valueType"
          />
        </b-form-group>

        <b-alert v-model="error" dismissible variant="danger">{{message}}</b-alert>
        <loading-button :is-busy="isBusyCreate" text="Создать"></loading-button>
      </b-form>
    </b-modal>

    <!-- table -->
    <div>
      <b-table striped hover show-empty ref="table" small
           :items="tableDataProvider"
           :fields="fields"
           :busy.sync="isBusy"
           empty-text="Нет контактов"
           empty-filtered-text="Не найдено"
           :per-page="perPage"
           :current-page="currentPage">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Загрузка...</strong>
          </div>
        </template>
        <template v-slot:cell(fio)="data">
          <router-link :to="{ name: 'Contact', params: { id: data.item.id }}">{{ contactFullName(data.item) }}</router-link>
        </template>
        <template v-slot:cell(company)="data">
          {{ data.item.company ? data.item.company.title : '' }}
        </template>
        <template v-slot:cell(phone)="data">
        {{ data.item.phone ? formatPhone(data.item.phone) : '' }}
        </template>
        <template v-slot:cell(actions)="data">
          <b-button-group>
            <b-button v-on:click="show(data.item.id)" variant="primary" size="sm">
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button v-on:click="remove(data.item.id)" variant="danger" size="sm">
              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-pagination align="center"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
  import LoadingButton from "../components/LoadingButton";
  import SearchForm from "../components/SearchForm";
  import commonMixin from '../mixins/common';
  import datapickerMixin from '../mixins/datapicker';

  export default {
    name: "Contacts",
    mixins: [commonMixin, datapickerMixin],
    components: {LoadingButton, SearchForm },
    data() {
      return {
        searchQuery: {
          query: '',
          tags: [],
          created_from: null,
          created_to: null
        },
        isBusy: false,
        isBusyCreate: false,
        totalRows: 1,
        errorResult: null,
        messageResult: '',
        perPage: 20,
        currentPage: 1,
        error: false,
        message: '',
        fields: [
          {key: 'fio', label: 'ФИО'},
          {key: 'company', label: 'Компания'},
          {key: 'phone', label: 'Телефон'},
          {key: 'email', label: 'E-mail'},
          {key: 'actions', label: 'Действия'}
        ],
        items: [],
        form: {
          first_name: '',
          last_name: '',
          middle_name: '',
          phone: '',
          email: '',
          birth_date: ''
        },
        isShowFilters: false,
      }
    },
    methods: {
      onCreateButton() {
        this.form.first_name = '';
        this.form.last_name = '';
        this.form.middle_name = '';
        this.form.phone = '';
        this.form.email = '';
        this.form.birth_date = '';
      },
      createContact(evt) {
        evt.preventDefault();
        this.error = false;
        this.isBusyCreate = true;
        this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/contacts/', JSON.stringify(this.form)
        ).then((response) => {
          this.isBusyCreate = false;
          if (response) {
            if (response.data.error === false) {
              this.$refs.table.refresh();
              this.error = false;
              this.$bvModal.hide('modal-1')
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
          .catch((error) => {
            console.log(error);
            this.isBusyCreate = false;
          })
      },
      submitSearch(evt) {
        evt.preventDefault();
        this.$refs.table.refresh();
      },
      resetSearch(evt) {
        evt.preventDefault();
        this.searchQuery.query = '';
        this.searchQuery.tags = [];
        this.searchQuery.created_from = null;
        this.searchQuery.created_to = null;
        this.$refs.table.refresh();
      },
      tableDataProvider(ctx) {
        const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/contacts/?page=' + ctx.currentPage + '&perpage=' +
          ctx.perPage + "&query=" + this.searchQuery.query +
          "&created_from=" + this.searchQuery.created_from +
          "&created_to=" + this.searchQuery.created_to + "&tags=" + JSON.stringify(this.searchQuery.tags));
        return promise.then(response => {
          this.items = response.data.contacts;
          this.totalRows = response.data.totalRows;
          return this.items || []
        }).catch((error) => {
          console.log(error);
          this.items = [];
          this.totalRows = 0;
          return this.items || []
        });
      },
      remove(id) {
        if (confirm("Удалить контакт #" + id + "?")) {
          this.error = false;
          this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/contacts/' + id, {}).then((response) => {
            if (response) {
              if (response.data.error === false) {
                this.error = false;
                this.$refs.table.refresh()
              } else {
                console.log(response.data.message);
              }
            }
          })
        }
      },
      show(id) {
        this.$router.push({name: 'Contact', params: {id: id}});
      }
    }
  }
</script>

<style scoped>

</style>
